module.exports = __webpack_public_path__ + "img/kleisma4-m@2.b463eb4b.webp";